import { FC } from 'react';

import type { TabType } from '../types/types';

import { ChevronLeftIcon } from '@heroicons/react/24/outline';

import NotificationList from '@/components/avatar/notification/notificationList';

interface INotification {
  setActiveTab: (tab: TabType) => void;
}

const NotificationTab: FC<INotification> = ({ setActiveTab }) => {
  return (
    <>
      <button
        className="flex font-jostRegular text-[#1F2B40] cursor-pointer items-center text-sm -ml-1 my-2"
        onClick={() => setActiveTab('default')}>
        <ChevronLeftIcon className="w-5 h-5 text-[#1F2B40]" />
        tilbage
      </button>
      <NotificationList />
    </>
  );
};

export default NotificationTab;
